"use client";

import { c as _c } from "react/compiler-runtime";
import { CookiesNextProvider } from "cookies-next";
import type { PropsWithChildren } from "react";
import { type ResolvedIntlConfig } from "react-intl";
import { ReactIntlProvider } from "@repo/i18n/provider";
// import { AnalyticsProvider } from "#/components/events/analytics-provider";
import { ReactQueryProvider } from "./react-query";
export function Providers(t0) {
  const $ = _c(6);
  const {
    children,
    defaultLocale,
    lang,
    messages
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      enabled: true,
      intervalMs: 1000
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== defaultLocale || $[3] !== lang || $[4] !== messages) {
    t2 = <CookiesNextProvider pollingOptions={t1}><ReactQueryProvider><ReactIntlProvider defaultLocale={defaultLocale} lang={lang} messages={messages}>{children}</ReactIntlProvider></ReactQueryProvider></CookiesNextProvider>;
    $[1] = children;
    $[2] = defaultLocale;
    $[3] = lang;
    $[4] = messages;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}